import(/* webpackMode: "eager" */ "/home/runner/work/web.drivingplus/web.drivingplus/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web.drivingplus/web.drivingplus/src/components/app-install-popup.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web.drivingplus/web.drivingplus/src/components/service-maintenance-overlay.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web.drivingplus/web.drivingplus/src/components/study-king-and-test40-result/main-section.tsx");
